module.exports = __webpack_public_path__ + "static/optimisation-a9435299e27d13e1b41135139626e986.jpg";